module.exports = __webpack_public_path__ + "static/media/THUGS-BNB.46cfdb3c.png";